import React from "react";
const ResponseViewRenderer = ({
  question,
  allResponses = [],
  canReviewEvidence = false,
  onEvidenceReview
}) => {

const formatDateTime = (dateString) => {

  if (!dateString) return "";

  const date = new Date(dateString);

  return date.toLocaleString(
    "en-IN",
    {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    }
  );
};
// =====================================
  // EVIDENCE
  // =====================================

  const renderEvidence = (
    evidence = []
  ) => {

    if (!evidence.length) {
      return null;
    }

    return (

      <div className="sr-attachments">

        <div className="sr-attachment-title">
          📎 Attachments
        </div>

        {
          evidence.map((file, index) => (
  <div
    key={index}
    className="sr-attachment-item"
  >
    <a
      href={file.file_url}
      target="_blank"
      rel="noreferrer"
      className="sr-attachment-link"
    >
      {file.file_name}
    </a>

    <div className="sr-evidence-actions">

      <span className={`sr-evidence-badge sr-evidence-${file.review_status || "pending"}`}>
       Status: {file.review_status || "pending"}
      </span>
      {file.review_status!= "pending" && file.reviewed_by_name && (
  <div className="sr-review-meta"> 
    Reviewed By: {file.reviewed_by_name} on {formatDateTime(file.reviewed_at)}

  </div>
  )}
    <div>
      {canReviewEvidence &&
      (
    !file.review_status ||
    file.review_status === "pending"
      ) && (
    <>
      <button className="ecf-remove-btn" onClick={() =>
    onEvidenceReview(
      file.file_id,
      "accepted"
    )
  }>✓</button>&nbsp;

      <button className="ecf-remove-btn" onClick={() =>
    onEvidenceReview(
      file.file_id,
      "rejected"
    )
  }>✕</button>
    </>
      )}
    </div>
    </div>

            {file.review_comment && (
              <div className="sr-evidence-comment">
                {file.review_comment}
              </div>
            )}
          </div>
        ))
        }

      </div>

    );
  };
  // =====================================
  // FORMAT
  // =====================================

  const formatValue = (value) => {

    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "--";
    }

    if (
      typeof value === "string" &&
      /^\d{4}-\d{2}-\d{2}$/.test(value)
    ) {

      const [year, month, day] =
        value.split("-");

      return `${day}-${month}-${year}`;
    }

    return value;
  };

  // =====================================
  // SINGLE
  // =====================================

  const renderSingle = (
    question
  ) => {

    if (
      question.data_type ===
      "boolean"
    ) {

      return (

        <div className="sr-boolean">

          {
            question.value == 1
              ? "Yes"
              : "No"
          }

        </div>

      );
    }

    return (

      <div className="sr-text">

        {
          formatValue(
            question.value
          )
        }

      </div>

    );
  };


  // =====================================
  // GROUPED
  // =====================================

 const renderGrouped = (
    question
  ) => {

    const details =
      Array.isArray(
        question.response_details
      )
        ? question.response_details[0] || {}
        : question.response_details || {};

    const fields =
      question.ui_schema
        ?.fields || [];

    return (

      <>
        <div className="sr-grid">

          {
            fields.map((field) => {

              let value =
                details[field.key];

              // FALLBACK

              if (
                value === undefined
              ) {

                const matchedKey =
                  Object.keys(details)
                    .find((k) =>
                      k.includes(
                        field.key
                      )
                    );

                value =
                  details[matchedKey];
              }
              if (field.options?.length) {

                const selectedOption =
                  field.options.find(
                    (o) =>
                      String(o.value) === String(value)
                  );

                if (selectedOption) {
                  value = selectedOption.label;
                }

              }

              return (

                <div
                  key={field.key}
                  className="sr-box"
                >

                  <label>
                    {field.label}
                  </label>

                  <div className="sr-text">

                    {
                      formatValue(
                        value
                      )
                    }

                  </div>

                </div>

              );
            })
          }

        </div>

        {
  question.system_value && (

    <div className="sr-result">

      <span>

        {
          question.ui_schema
            ?.derived
            ?.label ||

          question.ui_schema
            ?.summary
            ?.label ||

          "Summary"
        }

      </span>

     <strong>

  {
    Number(
      question.system_value
    ).toLocaleString(
      "en-IN",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    )
  }

  {
    question.data_type ===
      "percentage" ||

    question.question_text
      ?.includes("%") ||

    question.ui_schema
      ?.derived
      ?.label
      ?.includes("%")

      ? "%"

      : ""
  }

</strong>
    </div>

  )
}
      </>

    );
  };
  // =====================================
  // TABLE
  // =====================================

const renderTable = (
  question) => {
              const rows = question.response_details || [];
              
              const tableMeta = question.table_meta || {};

              const schemaRows = question.ui_schema?.rows || [];

              const columns = question.ui_schema?.columns || [];
              const schemaFields =
              schemaRows.filter(
                row => row.field_key
              );
            const beforeTableFields =
              schemaFields.filter(
                field =>
                  field.position === "before_table"
              );

            const afterTableFields =
              schemaFields.filter(
                field =>
                  field.position === "after_table"
              );
              let displayRows = [];

              // =====================================
              // FIXED ROW TABLES
              // Q13, Q14, Q15-B
              // =====================================

              if (
                question.ui_schema?.fixed_rows &&
                schemaRows.length > 0
              ) {

                schemaRows.forEach((schemaRow) => {

                 if (schemaRow.type === "section") {

                    displayRows.push(schemaRow);

                    return;
                  }

                  if (schemaRow.field_key) {
                    return;
                  }

                  const identifierKey =
                Object.keys(schemaRow).find((k) =>![
                  "type",
                  "label",
                  "readonly_row",
                  "field_key"
                ].includes(k)
                  );
                    if (!identifierKey) {
                    return;
                  }

          const responseRow =
            rows.find(
              (r) =>
                identifierKey &&
                r[identifierKey] ===
                schemaRow[identifierKey]
            );

                  displayRows.push(
                    responseRow || schemaRow
                  );

                });

    }

// =====================================
// DYNAMIC TABLES
// Q15-A and others
// =====================================

else {

  displayRows = rows;

}

const isStacked =
  question.ui_schema?.layout === "stacked";

  if (
  !rows.length &&
  !Object.keys(tableMeta).length
) {

  return (
    <p className="no-data">
      No data available
    </p>
  );

}
if (isStacked) {

return (
<div className="ecf-stacked-table">

  {rows.map((row, rowIndex) => (

    <div
      key={rowIndex}
      className="ecf-stacked-card"
    >

      {columns.map((column) => {

        let value = row[column.key];

          // Radio / Boolean
          if (
            column.type === "radio" ||
            column.type === "boolean"
          ) {
            value =
              String(value) === "1" ||
              value === true
                ? "Yes"
                : "No";
          }

          // Select
          else if (
            column.type === "select" &&
            column.options
          ) {
            const option =
              column.options.find(
                o => String(o.value) === String(value)
              );

            value =
              option?.label || value;
          }

        // Select label conversion

        if (
          column.type === "select" &&
          column.options
        ) {

          const option =
            column.options.find(
              o => o.value === value
            );

          value =
            option?.label || value;
        }

        return (

          <div
              key={column.key}
              className={`
                ecf-stacked-field
                ${
                  question.ui_schema?.grid_columns
                    ? `ecf-stacked-field-${question.ui_schema.grid_columns}`
                    : ""
                }
                ${
                  column.full_width
                    ? "ecf-stacked-field-full"
                    : ""
                }
              `}
            >

            <label>
              {column.label}
            </label>

            <div className="sr-text">
              {formatValue(value)}
            </div>

          </div>

        );

      })}

    </div>

  ))}

</div>

);

}
  return (

    <>
{beforeTableFields.map((field) => (

  <div
    key={field.field_key}
    className="sr-box"
    style={{ marginBottom: "20px" }}
  >

    <label>
      {field.label}
    </label>

    <div className="sr-text">
      {formatValue(
        tableMeta?.[field.field_key]
      )}
    </div>

  </div>

))}
  <div className="sr-table-wrapper">

        <table className="sr-table">

          <thead>

            <tr>

              {
                columns.map(
                  (column) => (

                    <th key={column.key}>
                      {column.label}
                    </th>

                  )
                )
              }

            </tr>

          </thead>

          <tbody>

            {
              displayRows.map(
                            (
                              row,
                              rowIndex
                            ) => {

                              if (row.type === "section") {

                                return (

                                  <tr
                                    key={`section-${rowIndex}`}
                                    className="ecf-section-row"
                                  >

                                    <td
                                      colSpan={columns.length}
                                    >

                                      <strong>
                                        {row.label}
                                      </strong>

                                    </td>

                                  </tr>

                                );

                              }

                              return (

                                <tr key={rowIndex}
                              className={
                                row.readonly_row
                                  ? "ecf-title"
                                  : ""
                              }>

                   {
              columns.map(
                (column) => {

                  let value =
                    row[column.key];

                  // =====================================
                  // SMART FALLBACKS
                  // =====================================

                  if (
                    value === undefined
                  ) {

                    // program_name -> program
                    // assessed_projects -> projects_assessed
                    // directors -> directors_complaints

                    const normalizedColumn =
                      column.key
                        .toLowerCase()
                        .replace(/_/g, "");

                    const matchedKey =
                      Object.keys(row)
                        .find((k) => {

                          const normalizedKey =
                            k
                              .toLowerCase()
                              .replace(/_/g, "");

                          return (

                            normalizedKey ===
                              normalizedColumn ||

                            normalizedKey.includes(
                              normalizedColumn
                            ) ||

                            normalizedColumn.includes(
                              normalizedKey
                            )
                          );
                        });

                    value =
                      row[matchedKey];
                  }

                  return (

                    <td
                      key={column.key}
                    >

                      {
                        formatValue(
                          value
                        )
                      }

                    </td>

                  );
                }
              )
                      }

                  </tr>

                );

              })
              }

          </tbody>

        </table>

      </div>
      {afterTableFields.map((field) => (

      <div
        key={field.field_key}
        className="sr-box"
        style={{ marginTop: "20px" }}
      >

    <label>
      {field.label}
    </label>

    <div className="sr-text">
      {formatValue(
        tableMeta?.[field.field_key]
      )}
    </div>

  </div>

))}
      
                {
        question.system_value && (

          <div className="sr-result">

            <span>

              {
                question.ui_schema
                  ?.summary
                  ?.label ||
                "Summary"
              }

            </span>

            <strong>

              {
                Number(
                  question.system_value
                ).toLocaleString(
                  "en-IN",
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }
                )
              }

            </strong>

          </div>

        )
      }
    </>

  );
  };

  // =====================================
  // DERIVED
  // =====================================

  const renderDerived = (question) => {

  const details =
    Array.isArray(question.response_details)
      ? question.response_details[0] || {}
      : question.response_details || {};

  // =====================================
  // AUTO SUMMARY QUESTIONS
  // =====================================

 if (question.ui_schema?.type === "auto_summary") {

  const rows =
    question.ui_schema?.rows || [];

  return (

    <>
      <div className="sr-table-wrapper">

        <table className="sr-table">

          <thead>

            <tr>
              <th>Parameter</th>
              <th>Current FY</th>
            </tr>

          </thead>

          <tbody>

            {rows.map((row, index) => {

              if (row.type === "section") {

                return (

                  <tr
                    key={index}
                    className="sr-section-row"
                  >

                    <td colSpan="2">
                      <strong>
                        {row.label}
                      </strong>
                    </td>

                  </tr>

                );
              }

              const value =
                row.source_key
                  ? details?.[row.source_key]
                  : details?.[row.field_key];

              return (

                <tr
                  key={
                    row.source_key ||
                    row.field_key ||
                    index
                  }
                >

                  <td>
                    {row.label}
                  </td>

                  <td>

                    {formatValue(value)}

                    {row.unit
                      ? ` ${row.unit}`
                      : ""}

                  </td>

                </tr>

              );

            })}

          </tbody>

        </table>

      </div>

      {question.system_value && (

        <div className="sr-result">

          <span>
            Summary
          </span>

          <strong>

            {Number(
              question.system_value
            ).toLocaleString(
              "en-IN",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            )}

          </strong>

        </div>

      )}

    </>

  );
}

  // =====================================
  // EXISTING DERIVED LOGIC
  // =====================================

  const fields =
    question.ui_schema?.fields || [];

  const isAggregationDerived =
    question.ui_schema?.aggregation === true;

  return (

    <>
      {!isAggregationDerived && (

        <div className="sr-grid">

          {fields.map((field) => {

            let value = "--";

            if (
              details &&
              Object.keys(details).length > 0
            ) {

              value =
                details[field.key];

              if (
                value === undefined
              ) {

                const matchedKey =
                  Object.keys(details)
                    .find((k) =>
                      k.includes(field.key)
                    );

                value =
                  details[matchedKey];
              }
            }

            if (
              (
                value === undefined ||
                value === null ||
                value === "--"
              ) &&
              field.source_question_code
            ) {

              const sourceQuestion =
                allResponses.find(
                  (q) =>
                    q.question_code ===
                    field.source_question_code
                );

              value =
                sourceQuestion?.system_value ||
                sourceQuestion?.value;
            }

            return (

              <div
                key={field.key}
                className="sr-box"
              >

                <label>
                  {field.label}
                </label>

                <div className="sr-text">
                  {formatValue(value)}
                </div>

              </div>

            );

          })}

        </div>

      )}

      <div className="sr-result">

        <span>

          {
            question.ui_schema?.display?.result_label ||

            question.ui_schema?.result?.label ||

            "Calculated Result"
          }

        </span>

        <strong>

          {question.system_value
            ? Number(
                question.system_value
              ).toLocaleString(
                "en-IN",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              )
            : "--"}

        </strong>

      </div>

    </>

  );
};

  // =====================================
  // MAIN
  // =====================================

  const renderContent = () => {

  switch (question.input_type) {

    case "single":
      return renderSingle(question);

    case "grouped":
      return renderGrouped(question);

    case "derived":
      return renderDerived(question);

    case "table":
      return renderTable(question);

    default:
      return (
        <div className="sr-text">
          Unsupported question type
        </div>
      );
  }
};

return (
  <>
    {renderContent()}

    {renderEvidence(
      question.evidence || []
    )}
  </>
);

};

export default ResponseViewRenderer;